import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { useShopModel } from "../shopModel";
import { YhBox } from "@/components/YhBox";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";


export const DataBox = () => {
    const { setIShopDrawer, selectedRowKeys, syncData } = useShopModel();
    const [syncLoading, setSyncLoading] = useState<boolean>(false);
    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => setIShopDrawer("add")}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ORG_SHOP_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要操作的数据");
                        return;
                    }
                    setIShopDrawer("edit");
                }}
            >编辑</Button>
        </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.DATA_SHOP_VW} >
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要操作的数据");
                        return;
                    }
                    setIShopDrawer("edit");
                }}
            >查看</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_SHOP_SYNC}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={syncLoading}
                onClick={() => {
                    setSyncLoading(true);
                    syncData().then(res => setSyncLoading(false)).catch(err => setSyncLoading(false));
                }}
            >{syncLoading ? "同步中" : "同步"}</Button>
        </YhAuth > */}
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}